import * as ExcelJs from 'exceljs'
import FileSaver from 'file-saver'
import React, { useEffect, useState } from 'react'
import { country, nationality } from '../Const/Constants'

interface IOnUploadProps {
  columns?: string[]
  customDataProcessing?: (
    currData: any[],
    setCurrData: React.Dispatch<any>
  ) => void
  findExistingData?: any
}
interface ISheetConfig {
  sheetName: string // "Student", "Lecturer", "MenuItemList"
  headerSetup: ITemplateProps[] // array for that sheet
}

interface IDownloadProps {
  name: string
  // workSheetName: string
  sheet: ISheetConfig[]
  // headerSetup: ITemplateProps[]
  isHeaderLocked: boolean
  defaultHeaderFillStyle?: any
  defaultHeaderBorderStyle?: any
  headerStyle?: IHeaderStyle[]
  sheetPassword?: string
  protectWholeSheet?: boolean
  listType?: IListType
  extraListData?: IExtraListData[]
}

// get the data from user to create a dynamic selection listing
interface IExtraListData {
  data: string[]
  worksheetName: string
  dataType: string
}

// for now since worker profile hasCountry
// hasNationality
interface IListType {
  hasCountry?: boolean
  hasNationality?: boolean
}

interface IHeaderStyle {
  col: number
  fillStyle: ExcelJs.Fill
  borderStyle: Partial<ExcelJs.Borders>
}

interface ISelectedFileProps {
  event: any
}

interface ITemplateProps {
  header: Partial<ExcelJs.Column>
  // dataType?: keyof dataType
  // dataType?: 'TrueOrFalse' | 'country' | 'nationality'
  dataType?: string
}

// declare type dataType = {
//   TrueOrFalse: 'TrueOrFalse'
//   country: 'country'
//   nationality: 'nationality'
// }

export const useExcelUploadVersion2 = () => {
  const [fileTitle, setFileTitle] = useState<string>('') // value to display as placeholder
  const [openFileUpload, setOpenFileUpload] = useState<boolean>(false) // just Bool to open dialog
  const [currentData, setCurrentData] = useState(null) // keep track excel's data
  const [errorDialog, setErrorDialog] = useState<boolean>(false)
  const [onSave, setSave] = useState<boolean>(false)
  const [currFile, setCurrFile] = useState<any>()
  const [duplicateItems, setDuplicateItems] = useState<string[]>([])
  const [hasDuplicate, setHasDuplicate] = useState<number>(0)
  const [isEmpty, setIsEmpty] = useState<boolean>(false)
  const [worksheet, setWorksheet] = useState(null)

  // SNACKBAR STUFF
  // SNACKBAR STUFF

  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [snackBarMessage, setSnackBarMessage] = useState('')

  const snackFunc = (showText: string, ms: number) => {
    setSnackBarMessage(showText)
    setOpenSnackBar(true)
    setTimeout(() => {
      setSnackBarMessage('')
      setOpenSnackBar(false)
    }, ms)
  }

  const options: Partial<ExcelJs.WorksheetProtection> = {
    selectLockedCells: true,
    selectUnlockedCells: true,
    formatColumns: true,
    formatCells: true,
    insertRows: true,
    autoFilter: true,
    deleteRows: true,
    scenarios: true,
    objects: true,
  }

  // GLOBAL VAR
  // GLOBAL VAR
  // GLOBAL VAR

  const wb = new ExcelJs.Workbook()

  // GETTING THE HEADER SETUP AND ANY EXTRA CONFIGURATIONS
  // GETTING THE HEADER SETUP AND ANY EXTRA CONFIGURATIONS
  // GETTING THE HEADER SETUP AND ANY EXTRA CONFIGURATIONS

  const downloadTemplateSetup = (
    template: {
      sheetName: string
      headerSetup: ITemplateProps[]
    }[]
  ) => {
    let header = [],
      additionalCellSettings = []
    let sheets = []
    template?.forEach(({ sheetName, headerSetup }) => {
      let header: Partial<ExcelJs.Column>[] = []
      let additionalCellSettings = []

      headerSetup.forEach((val, index) => {
        // Push ExcelJS column definition
        header.push(val?.header)

        if (!!val?.dataType) {
          additionalCellSettings.push({
            dataType: val.dataType,
            colNo: index + 1,
          })
        }
      })
      sheets.push({
        sheetName,
        header,
        additionalCellSettings,
      })
    })
    // template?.map((val, index) => {
    //   header.push(val?.headerSetup.header)
    //   if (!!val?.dataType)
    //     additionalCellSettings.push({
    //       dataType: val?.dataType,
    //       colNo: index + 1,
    //     })
    // })

    // return {
    //     header,
    //     additionalCellSettings,
    //   }
    return sheets
  }

  // CREATE HIDDEN WS FOR DYNAMIC DATA SELECTION
  // CREATE HIDDEN WS FOR DYNAMIC DATA SELECTION
  // CREATE HIDDEN WS FOR DYNAMIC DATA SELECTION

  const createHiddenWorkSheet = (
    wb: ExcelJs.Workbook,
    worksheetName: string,
    columnData: string[]
  ) => {
    const hiddenWs: ExcelJs.Worksheet = wb.addWorksheet(worksheetName, {
      state: 'hidden',
    })

    hiddenWs.getColumn(1).values = columnData
  }

  // CREATING EXCEL TEMPLATE
  // CREATING EXCEL TEMPLATE
  // CREATING EXCEL TEMPLATE

  const onDownloadTemplate = async (props: IDownloadProps) => {
    try {
      const {
        // workSheetName,
        isHeaderLocked,
        sheet,
        // headerSetup,
        sheetPassword,
        defaultHeaderBorderStyle,
        defaultHeaderFillStyle,
        headerStyle,
        name,
        protectWholeSheet = false,
        listType,
        extraListData,
      } = props

      let data: any

      const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'

      // initializing the workbook

      wb.properties.date1904 = true
      wb.calcProperties.fullCalcOnLoad = true
      // const ws: ExcelJs.Worksheet = wb.addWorksheet(workSheetName)

      // since formula in excel has 255 words limit
      // needs another worksheet to initialize the selections
      // if (listType) {
      //   if (listType?.hasCountry) {
      //     const conWs: ExcelJs.Worksheet = wb.addWorksheet('countries', {
      //       state: 'hidden',
      //     })

      //     conWs.getColumn(1).values = country
      //   }

      //   if (listType?.hasNationality) {
      //     const natWs: ExcelJs.Worksheet = wb.addWorksheet('nationalities', {
      //       state: 'hidden',
      //     })

      //     natWs.getColumn(1).values = nationality
      //   }
      // }

      // if (extraListData?.length > 0) {
      //   extraListData?.map(v => {
      //     createHiddenWorkSheet(wb,
      //       v.worksheetName

      //       , v.data)
      //   })
      // }
      const sheetConfigs = downloadTemplateSetup(sheet)
      const normalize = name =>
        name
          ?.toLowerCase()
          .replace(/\s+/g, '')
          .trim()
      const requiredDataTypes = new Set<string>()
      sheetConfigs.map(cfg => {
        const ws = wb.addWorksheet(cfg.sheetName)
        ws.columns = cfg.header

        // const { header, additionalCellSettings } = downloadTemplateSetup([
        //   {
        //     sheetName:workSheetName,
        //     headerSetup
        //   }

        // ]
        //   // headerSetup
        // )
        // const { header, additionalCellSettings } = sheetConfigs[0];
        // // initiate header
        // ws.columns = header

        // unprotect the column to be inserted
        if (!protectWholeSheet) {
          // for (let i = 0; i < header.length; i++) {
          //   ws.getColumn(i + 1).protection = { locked: false }
          // }
          cfg.header.map((_col, index) => {
            ws.getColumn(index + 1).protection = { locked: false }
          })
        }

        cfg.additionalCellSettings.forEach(v => {
          requiredDataTypes.add(normalize(v.dataType))
          if (requiredDataTypes.has('country')) {
            if (!wb.getWorksheet('countries')) {
              const conWs = wb.addWorksheet('countries', { state: 'hidden' })
              conWs.getColumn(1).values = country
            }
          }

          if (requiredDataTypes.has('nationality')) {
            if (!wb.getWorksheet('nationalities')) {
              const natWs = wb.addWorksheet('nationalities', {
                state: 'hidden',
              })
              natWs.getColumn(1).values = nationality
            }
          }

          const col = ws.getColumn(v.colNo)

          col.values = new Array(3000).fill('')

          col.eachCell((cell, rowNo) => {
            if (rowNo === 1) cell.value = cfg.header[v.colNo - 1]?.header

            if (v.dataType === 'TrueOrFalse') {
              ws.getCell(cell.address).dataValidation = BOOLEAN_TYPE_DATA
            }
            if (v.dataType === 'nationality') {
              ws.getCell(cell.address).dataValidation = NATIONALITY_TYPE_DATA
            }
            if (v.dataType === 'country') {
              ws.getCell(cell.address).dataValidation = COUNTRY_TYPE_DATA
            }
            if (v.dataType === 'wageType') {
              ws.getCell(cell.address).dataValidation = WAGES_TYPE_DATA
            }
            if (v.dataType === 'date') {
              ws.getCell(cell.address).dataValidation = DATE_TYPE_DATA as any
            }

            // Extra list data dropdowns
            extraListData?.forEach(w => {
              const key = normalize(w.dataType)

              if (requiredDataTypes.has(key)) {
                if (!wb.getWorksheet(w.worksheetName)) {
                  createHiddenWorkSheet(wb, w.worksheetName, w.data)
                  if (v.dataType === w.dataType) {
                    ws.getCell(cell.address).dataValidation = CREATE_LIST_TYPE(
                      `=${w.worksheetName}!$A$1:$A$${w.data.length + 1}`
                    ) as any
                  }
                }
              }
              // if (v.dataType === w.dataType) {
              //   ws.getCell(cell.address).dataValidation = CREATE_LIST_TYPE(
              //   `=${w.worksheetName}!$A$1:$A$${w.data.length + 1}`
              //   ) as any
              // }
            })
          })
        })
        ws.views = [{ state: 'frozen', ySplit: 1 }]

        if (isHeaderLocked) ws.getRow(1).protection = { locked: true }
        if (!!defaultHeaderFillStyle || !!defaultHeaderBorderStyle) {
          ws.getRow(1).eachCell(cell => {
            cell.fill = defaultHeaderFillStyle
            cell.border = defaultHeaderBorderStyle
          })
        }

        // if (headerStyle?.length > 0) {
        //   headerStyle.forEach(val => {
        //     if (val.col > header.length)
        //       throw new Error('The column does not exists')
        //     else {
        //       ws.getCell(1, val.col).fill = val.fillStyle
        //       ws.getCell(1, val.col).border = val.borderStyle
        //     }
        //   })
        // }
        // console.log(additionalCellSettings, 'additional settings')

        // if (!!additionalCellSettings) {
        //   additionalCellSettings.map((v, i) => {
        //     // capping the values in 3000 -- considerably large number
        //     // to speed up the process of creating template (increase if necessary)
        //     // initialize the cell with empty values just to do cell data validation
        //     // this allow the cell to be validate with our own data validation
        //     // for now only has boolean value
        //     let values = new Array(3000).fill('')
        //     ws.getColumn(v.colNo).values = values

        // ws.getColumn(v.colNo).eachCell((cell, rowNo) => {
        //   // redefined the values of the header since it got overwrote by prev lines
        //   if (rowNo === 1) cell.value = header[v.colNo - 1]?.header

        //   // for now according to contract, there are column that only consists of true of false value
        //   if (v.dataType === 'TrueOrFalse') {
        //     ws.getCell(cell.address).dataValidation = BOOLEAN_TYPE_DATA
        //   }
        //   if (v.dataType === 'nationality') {
        //     ws.getCell(cell.address).dataValidation = NATIONALITY_TYPE_DATA
        //   }
        //   if (v.dataType === 'country') {
        //     ws.getCell(cell.address).dataValidation = COUNTRY_TYPE_DATA
        //   }
        //   if (v.dataType === 'wageType') {
        //     ws.getCell(cell.address).dataValidation = WAGES_TYPE_DATA
        //   }
        //   if (v.dataType === 'date') {
        //     ws.getCell(cell.address).dataValidation = DATE_TYPE_DATA as any
        //   }
        //   // if (v.dataType === 'jobType') {
        //   //   ws.getCell(cell.address).dataValidation = DATE_TYPE_DATA as any
        //   // }

        //   if (extraListData?.length > 0) {
        //     extraListData?.map(w => {
        //       if (v.dataType === w.dataType) {
        //         ws.getCell(cell.address).dataValidation = CREATE_LIST_TYPE(
        //           `=${w.worksheetName}!$A$1:$A$${w.data.length + 1}`
        //         ) as any
        //       }
        //     })
        //   }
        //   // can add other datatypes as you want
        //   // will make it dynamic in the future
        // })
        //   })
        // }

        // // header doesnt move in view
        // ws.views = [{ state: 'frozen', ySplit: 1 }]

        // // lock the header if user cannot change the header
        // if (isHeaderLocked) ws.getRow(1).protection = { locked: true }

        // // default styles (if provided) set to each one of the headers
        // if (!!defaultHeaderFillStyle || !!defaultHeaderBorderStyle) {
        //   ws.getRow(1).eachCell(cell => {
        //     cell.fill = defaultHeaderFillStyle
        //     cell.border = defaultHeaderBorderStyle
        //   })
        // }

        // // custom styles (if provided) can be given to specific col by column
        // // number as the position
        // if (headerStyle?.length > 0) {
        //   headerStyle.forEach(val => {
        //     if (val.col > header.length)
        //       throw new Error('The column does not exists')
        //     else {
        //       ws.getCell(1, val.col).fill = val.fillStyle
        //       ws.getCell(1, val.col).border = val.borderStyle
        //     }
        //   })
        // }

        // protect the whole excel sheet (with password provided
        // or default [THIS IS SET BY ME!])
        ws.protect(sheetPassword ? sheetPassword : 'contX@gen-Set', options)
      })
      const buffer = await wb.xlsx.writeBuffer()
      // download part
      data = new Blob([buffer], { type: fileType })
      FileSaver.saveAs(data, name)
    } finally {
    }
  }

  // WHEN EXCEL FILE IS SELECTED
  // WHEN EXCEL FILE IS SELECTED
  // WHEN EXCEL FILE IS SELECTED

  const onSelectFile = async (props: ISelectedFileProps) => {
    const { event } = props
    let isValid: boolean = false

    const file: File = event.target.files[0]
    setCurrFile(file)

    if (!!file) {
      isValid =
        file.type === 'application/vnd.ms-excel' ||
        file.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ? true
          : false
    }

    // initialize and read/load file buffer
    if (isValid === true) {
      // const wb = new ExcelJs.Workbook()
      // const ws=
      await wb.xlsx.load(event.target.files[0])
      // console.log("wb",wb);
      console.log('file', event.target)

      // get the worksheet (1 here because each excel has only one worksheet)
      // can be changed to use name of the specific worksheet in case there are multiple ws
      // const ws = wb.getWorksheet(1)

      // let dataCollected = [],
      // let columnNames = [];
      // let sheetsData: any[] = [];
      // let dataCollected: any[] = [],
      const sheetsData = []
      // columnNames
      setFileTitle(file.name)

      const toArray = (values: any): any[] => {
        return Array.isArray(values) ? [...values] : Object.values(values)
      }
      const processWorksheet = (ws: ExcelJs.Worksheet) => {
        let columnNames: any[] = []
        let dataCollected: any[] = []
        let allRows: any[] = []
        ws.eachRow({ includeEmpty: true }, (row, rowNo) => {
          let values = Array.isArray(row.values)
            ? [...row.values]
            : Object.values(row.values)

          values.shift()

          if (rowNo === 1) {
            columnNames = values
          } else {
            allRows.push(values)
          }
        })

        // 🔥 Remove trailing completely empty rows
        let lastRealIndex = -1

        for (let i = allRows.length - 1; i >= 0; i--) {
          const hasRealValue = allRows[i].some(
            v =>
              v !== undefined &&
              v !== null &&
              !(typeof v === 'string' && v.trim() === '')
          )

          if (hasRealValue) {
            lastRealIndex = i
            break
          }
        }

        const trimmedRows =
          lastRealIndex === -1
            ? [] // no real data rows exist
            : allRows.slice(0, lastRealIndex + 1)

        const processedRows = trimmedRows.map(row =>
          basicDataProcessing(row, columnNames)
        )

        if (processedRows.length === 0 && columnNames.length > 0) {
          const emptyRow: any = {}
          columnNames.forEach(col => {
            emptyRow[col] = undefined
          })

          processedRows.push(emptyRow)
        }
        // ws.eachRow({ includeEmpty: true }, (row, rowNo) => {
        //   let values = toArray(row.values) // copy values
        //   values.shift() // remove ExcelJS dummy index
        //   const isRowReallyEmpty = (value: any[]) => {
        //     return value.every(v => v === undefined || v === null || (typeof v === "string" && v.trim() === ""))
        //   }
        //   if (rowNo === 1) {
        //     columnNames = values
        //   }
        //   // else if (!isRowEmpty(values)) {
        //   //   dataCollected.push(basicDataProcessing(values, columnNames))
        //   // }
        //   else{
        //     dataCollected.push(basicDataProcessing(values, columnNames))
        //   }
        // })

        return {
          sheetName: ws.name,
          // rows: dataCollected,
          rows: processedRows,
        }
      }
      wb.eachSheet(ws => {
        const result = processWorksheet(ws)
        console.log('result', result)

        sheetsData.push(result)
      })

      setCurrentData(sheetsData)
      // wb.eachSheet(ws=>{
      //   const result = processWorksheet(ws);

      //   sheetsData.push({
      //     sheetName:ws.name,
      //     rows: result.rows
      //   });
      // });

      // setCurrentData(sheetsData)

      //   return {
      //     sheetName:ws.name,
      //     rows:dataCollected
      //   };
      // };

      // const normalize = (name) =>
      // name?.toLowerCase().replace(/\s+/g, "").trim();

      // if (targetSheetName) {
      //   const ws = wb.getWorksheet(targetSheetName);
      //   console.log('ws wb',ws,wb);

      //   if (!ws) {
      //     snackFunc(`Sheet '${targetSheetName}'not found!`,1500);
      //     return;
      //   }

      //   const sheetResult =processWorksheet(ws);
      //   console.log('sheetResult',sheetResult);

      //   setCurrentData([{sheetName:targetSheetName,rows:sheetResult.rows}]);
      //   console.log('CurrentData Sheet',currentData);
      //   console.log("not targetSheetname",!targetSheetName);

      //   return;
      // }

      // if (!targetSheetName) {
      //   let sheetsData: any[] = [];

      //   wb.eachSheet((ws)=>{
      //     const result = processWorksheet(ws);

      //     if (result.rows.length>5000) {
      //       result.rows = result.rows.slice(0,5000);
      //     }
      //     sheetsData.push({
      //       sheetName:ws.name,
      //       rows:result.rows
      //     });
      //     console.log("sheetData",sheetsData);

      //   })
      //   setCurrentData(sheetsData);
      // }
      // wb.eachSheet((ws,sheetId)=>{
      // let dataCollected: any[] = [];
      // let columnNames: any[] = [];
      // console.log("ws123",ws);

      // ws.eachRow({ includeEmpty: true }, (row, rowNo) => {

      //   let raw = row.values;
      //   let arr = Array.isArray(raw) ? [...raw] : [...Object.values(raw)];
      //   arr.shift();

      //   if (rowNo === 1) {
      //     columnNames = arr;
      //   } else if (!isRowEmpty(arr)) {
      //     dataCollected.push(basicDataProcessing(arr, columnNames));
      //   }
      //   // let currRow = null
      //   // if (rowNo !== 1) {
      //   //   currRow = row.values
      //   //   currRow.shift()
      //   // } else {
      //   //   columnNames = row.values
      //   //   columnNames.shift()
      //   // }

      //   // if (rowNo > 1 && !isRowEmpty(currRow))
      //   //   dataCollected.push(basicDataProcessing(currRow, columnNames))
      // })
      // sheetsData.push({
      //   sheetName: ws.name,
      //   rows: dataCollected
      // })
      // })
      // populate the data for each row

      // console.log(dataCollected, '>>>>>>>>>>>>>>')
      // setCurrentData([...dataCollected])
      // setCurrentData(sheetsData)
    } else {
      snackFunc('Invalid file type!', 1000)
      return
    }
  }

  /// SOME PRE-DEFINED FUNCTION FOR PROCESSING DATA (BASIC PER LINE DATA)
  /// SOME PRE-DEFINED FUNCTION FOR PROCESSING DATA (BASIC PER LINE DATA)
  /// SOME PRE-DEFINED FUNCTION FOR PROCESSING DATA (BASIC PER LINE DATA)

  const basicDataProcessing = (data: any[], columns: any[]) => {
    let processedData = null
    // let processedData: any = {}

    if (data?.length > 0) {
      columns?.map((val, index) => {
        let temp = {
          [val]: data[index],
        }

        if (!!temp) processedData = { ...processedData, ...temp }
      })
    }
    return processedData
  }

  const isRowEmpty = (row: any) => {
    return row.filter(v => v).length === 0
  }

  // UPLOADING OWN TEMPLATE
  // UPLOADING OWN TEMPLATE
  // UPLOADING OWN TEMPLATE

  const [hasCheckDup, setHasCheckDup] = useState<boolean>(false)

  const onUploadTemplate = async (props: IOnUploadProps) => {
    const { columns, customDataProcessing, findExistingData } = props
    let index_of_headers_map: any = {}

    // if (currFile)
    await wb.xlsx.load(currFile)

    const ws = wb.getWorksheet(1)
    setWorksheet(ws)
    console.log('wb', wb, ws)

    // initialize the header of the index in map
    worksheet.getRow(1).eachCell((cell, colNo) => {
      index_of_headers_map[cell.value as string] = colNo
    })

    // check if the column is empty
    if (!currentData || currentData?.length === 0) {
      snackFunc('Excel file is empty', 4000)
      setIsEmpty(true)
      return
    }
    // check if there are any duplicate items
    if (currentData && columns && columns.length > 0) {
      for (const sheet of currentData) {
        const rows = sheet.rows

        if (rows.length === 0) continue

        for (const col of columns) {
          const colValues = rows
            .map((r: any) => r[col])
            .filter((v: any) => v !== null && v !== undefined)

          if (arrayHasDuplicates(colValues)) {
            snackFunc(`Excel file contain duplicates`, 4000)
            setHasDuplicate(hasDuplicate + 1)
            return
          }
        }
      }
    }
    // if (currentData) {
    //   columns.map(x => {
    //     let currColumn = ws.getColumn(index_of_headers_map[x])?.values as any
    //     let currColValues = currColumn.filter(x => x).slice(1) // slice to remove header value

    //     // this is just basic as it check all the values inside the column itself
    //     if (arrayHasDuplicates(currColValues)) {
    //       snackFunc(`Excel file contain duplicates`, 4000)
    //       setHasDuplicate(hasDuplicate + 1)
    //       return
    //     }
    //   })
    // }

    if (!!customDataProcessing) {
      customDataProcessing(currentData, setCurrentData)
    }
    // if (customDataProcessing) {
    //   currentData.map(sheet=>{
    //     customDataProcessing(sheet.roes,(updateRows: any[])=>{
    //       sheet.rows = updateRows;
    //     })
    //   })
    //   setCurrentData([...currentData])
    // }
    if (!!findExistingData) {
      await findExistingData()
    }

    // duplicate Items -- checking between excel and existing data
    // hasDuplicate -- check if there is any duplicates inside the excel itself
    // isEmpty -- check if the excel is empty
    // if (!isEmpty && hasDuplicate === 0) {
    //   setSave(true)
    // } else {
    //   setSave(false)
    //   // if (duplicateItems?.length > 0) {
    //   //   setErrorDialog(true)
    //   // }
    // }
  }

  // duplicate Items -- checking between excel and existing data
  // hasDuplicate -- check if there is any duplicates inside the excel itself
  // isEmpty -- check if the excel is empty
  // SINCE CONTRACT GENERAL SETTING HAS CHECKING FOR ALL OF THE MATERIALS
  // THEN IT'S LOGICAL TO PUT HAS CHECK DUP AS A TIE BREAKER TO SOLVE THE ENTIRE
  // THING SINCE THE DEFAULT VALUE OF ALL OF THEM CAUSE THIS USEEFFECT TO SET THE ONSAVE
  // VALUE TO BE TRUE IN THE FIRST PLACE WITHOUT ACTUALLY CHECKING THE DATA FROM THE EXCEL
  useEffect(() => {
    if (
      hasCheckDup &&
      duplicateItems.length === 0 &&
      !isEmpty &&
      hasDuplicate === 0
    ) {
      setSave(true)
    } else {
      setSave(false)
    }
  }, [hasCheckDup, isEmpty, hasDuplicate, duplicateItems])

  const resetFileUpload = () => {
    setIsEmpty(false)
    setHasDuplicate(0)
    setSave(false)
  }

  ///PREDEFINED CHECKING DUPLICATE FUNCTION
  ///PREDEFINED CHECKING DUPLICATE FUNCTION
  ///PREDEFINED CHECKING DUPLICATE FUNCTION

  // return true if arr has duplicates
  const arrayHasDuplicates = (arr: any) => {
    let arrayContainDuplicates = new Set(arr).size !== arr.length

    if (arrayContainDuplicates) {
      findDuplicateValues(arr)
    }

    return arrayContainDuplicates
  }

  /// DATA PROCESSING FOR BUIDLING MATERIAL CONTRACTX
  /// DATA PROCESSING FOR BUIDLING MATERIAL CONTRACTX
  /// DATA PROCESSING FOR BUIDLING MATERIAL CONTRACTX

  interface IBuildingMaterialCustomProps {
    name: string
    items: string[]
  }

  const buildingMaterialDataProcessing = (
    currData: any[],
    setCurrData: React.Dispatch<any>,
    data_from_user?: any[]
  ) => {
    let finalData: IBuildingMaterialCustomProps[] = []
    let name: string = ''
    let nameArr: string[] = []
    let nameIndex: number
    currData?.map((v, i) => {
      name = v?.name

      if (name) {
        nameArr.push(name)

        // check to see duplicates inside building materials
        if (!!finalData && finalData[nameIndex]) {
          if (arrayHasDuplicates(finalData[nameIndex]?.items)) {
            snackFunc(`Excel file contain duplicates`, 4000)
            return
          }
        }

        nameIndex = nameArr.length - 1
      }

      if (name && !!!finalData[nameIndex]) {
        finalData.push({ name: '', items: [] })
      }

      if (name && !!finalData[nameIndex]) {
        finalData[nameIndex].name = v.name
        finalData[nameIndex].items.push(v.item)
      } else if (!name && !!finalData[nameIndex]) {
        finalData[nameIndex].items.push(v.item)
      }
    })

    extractExistingValues(
      nameArr.map(v => v.toLowerCase()),
      data_from_user
    )

    setCurrData([...finalData])
  }

  interface IPNMProps {
    name: string
    pnmCostCat: PNMCostCategoryProps
  }

  interface PNMCostCategoryProps {
    roadTax: boolean
    insurance: boolean
    warranty: boolean
    quantity: boolean
  }

  const PNMDataProcessing = (
    currData: any[],
    setCurrData: React.Dispatch<any>,
    data_from_user?: string[]
  ) => {
    let finalData: IPNMProps[] = []
    let stringOfArr: string[] = []

    currData?.map((v, i) => {
      stringOfArr.push(v?.name?.toLowerCase())
      finalData.push({
        name: v?.name,
        pnmCostCat: {
          insurance: v?.insurance,
          quantity: v?.quantity,
          roadTax: v?.roadTax,
          warranty: v?.warranty,
        },
      })
    })

    extractExistingValues(stringOfArr, data_from_user)

    setCurrData([...finalData])
    // return existedValue
  }

  // PREDEFINED FINDING EXISTING VALUES FOR CONTRACT
  // PREDEFINED FINDING EXISTING VALUES FOR CONTRACT
  // PREDEFINED FINDING EXISTING VALUES FOR CONTRACT

  // compare name array from excel and name array from query
  const extractExistingValues = (
    data_from_excel: string[],
    provided_data: string[]
  ) => {
    let existedValue = []
    let excel_set = new Set(data_from_excel)
    let provided_data_set = new Set(provided_data)

    // console.log('does it come here?')

    excel_set.forEach(v => {
      if (provided_data_set.has(v)) existedValue.push(v)
    })

    setDuplicateItems([...existedValue])
    if (existedValue?.length > 0) setErrorDialog(true)
    else setHasCheckDup(true)
  }

  // PREDEFINED FINDING EXISTING VALUES FOR BUILDING MATERIAL CONTRACT
  // PREDEFINED FINDING EXISTING VALUES FOR BUILDING MATERIAL CONTRACT
  // PREDEFINED FINDING EXISTING VALUES FOR BUILDING MATERIAL CONTRACT

  return {
    openFileUpload,
    setOpenFileUpload,
    /////////////////////////
    fileTitle,
    setFileTitle,
    /////////////////////////
    openSnackBar,
    setOpenSnackBar,
    snackBarMessage,
    setSnackBarMessage,
    /////////////////////////
    currentData,
    setCurrentData,
    /////////////////////////
    // itemError,
    onSave,
    duplicateItems,
    errorDialog,
    setErrorDialog,
    resetFileUpload,
    /////////////////////////
    onDownloadTemplate,
    onSelectFile,
    onUploadTemplate,
    ///////////////// SPECIFIC DATA PROCESSING
    buildingMaterialDataProcessing,
    PNMDataProcessing,
    extractExistingValues,
    //////////////////////////////
  }
}

const BOOLEAN_TYPE_DATA: ExcelJs.DataValidation = {
  type: 'list',
  allowBlank: true,
  formulae: ['"True, False"'],
  showErrorMessage: true,
  errorStyle: 'error',
  errorTitle: 'True or False',
  error: 'The value must be True or False only',
}

const COUNTRY_TYPE_DATA: ExcelJs.DataValidation = {
  type: 'list',
  allowBlank: true,
  formulae: ['=countries!$A$1:$A$253'],
  showErrorMessage: true,
  errorStyle: 'error',
  errorTitle: 'Error',
  error: 'The value must be from list',
}

const NATIONALITY_TYPE_DATA: ExcelJs.DataValidation = {
  type: 'list',
  allowBlank: true,
  formulae: ['=nationalities!$A$1:$A$113'],
  showErrorMessage: true,
  errorStyle: 'error',
  errorTitle: 'Error',
  error: 'The value must be from list',
}

const WAGES_TYPE_DATA: ExcelJs.DataValidation = {
  type: 'list',
  allowBlank: true,
  formulae: ['"Hourly, Daily, Monthly"'],
  showErrorMessage: true,
  errorStyle: 'error',
  errorTitle: 'Error',
  error: 'The value must be from list',
}

const DATE_TYPE_DATA = {
  allowBlank: true,
  formulae: ['"=TODAY()"'],
  type: 'date',
  operator: 'greaterThanOrEqual',
  showInputMessage: true,
  promptTitle: 'Expiry Date',
  prompt: 'Format (DD/MM/YYYY)',
  showErrorMessage: true,
  errorStyle: 'error',
  errorTitle: 'Error',
  error: 'Invalid Date/Date should not be less than today',
}

// can change the properties to suit your needs
const CREATE_LIST_TYPE = (formula: string) => {
  return {
    type: 'list',
    allowBlank: true,
    formulae: [formula],
    showErrorMessage: true,
    errorStyle: 'error',
    errorTitle: 'Error',
    error: 'The value must be from the list',
  }
}

// FIND DUPLICATE VALUES IN ARRAY ITSELF
// FIND DUPLICATE VALUES IN ARRAY ITSELF
// FIND DUPLICATE VALUES IN ARRAY ITSELF

const findDuplicateValues = (arr: any[]) => {
  var set = new Set()
  var duplicates = new Set()
  for (let i = 0; i < arr.length; i++) {
    var size = set.size
    set.add(arr[i])
    if (set.size === size) {
      duplicates.add(arr[i])
    }
  }
  return duplicates
}
